var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph_4be73cyqv8hf 1",
    clipPath: "url(#clip0_5302_36056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6667 18.7H19.3333V0.366667C19.3333 0.146667 19.2 0 19 0H15C14.8 0 14.6667 0.146667 14.6667 0.366667V18.7H12.3333V9.9C12.3333 9.68 12.2 9.53333 12 9.53333H8C7.8 9.53333 7.66667 9.68 7.66667 9.9V18.7H5.33333V14.3C5.33333 14.08 5.2 13.9333 5 13.9333H1C0.8 13.9333 0.666667 14.08 0.666667 14.3V18.7H0.333333C0.133333 18.7 0 18.8467 0 19.0667C0 19.2867 0.133333 19.4333 0.333333 19.4333H19.6667C19.8667 19.4333 20 19.2867 20 19.0667C20 18.8467 19.8667 18.7 19.6667 18.7ZM4.66667 18.7H1.33333V14.6667H4.66667V18.7ZM11.6667 18.7H8.33333V10.2667H11.6667V18.7ZM18.6667 18.7H15.3333V0.733334H18.6667V18.7Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.4
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5302_36056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.81e685e24cee96e1e4176242b0ee7335.svg";
export { ForwardRef as ReactComponent };